var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkle01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 142,
    viewBox: "0 0 119 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_228_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.164 85.7291L75.2823 68.5506C73.4813 67.3074 72.7762 64.9855 73.5872 62.9287L89.2188 23.0299C90.1105 20.76 89.1512 18.1956 86.9966 17.0968C84.8421 15.998 82.203 16.7274 80.8893 18.782L57.7723 54.8633C56.5894 56.7164 54.2902 57.5202 52.2263 56.7924L23.7107 46.7391C21.4799 45.9543 19.0109 46.9539 17.9311 49.0713L17.8054 49.3178C16.7255 51.4352 17.3662 54.0207 19.3113 55.3655L44.1932 72.5441C45.9943 73.7873 46.6994 76.1091 45.8883 78.166L30.2568 118.065C29.3651 120.335 30.3244 122.899 32.4789 123.998C34.6335 125.097 37.2725 124.367 38.5863 122.313L61.7033 86.2313C62.8862 84.3783 65.1854 83.5744 67.2492 84.3023L95.7649 94.3556C97.9957 95.1403 100.465 94.1407 101.544 92.0233L101.67 91.7769C102.75 89.6594 102.109 87.074 100.164 85.7291Z",
    fill: "#FF8BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.061 81.539L103.058 81.537L78.4297 64.5332L93.9602 24.8925C93.9603 24.8921 93.9604 24.8918 93.9606 24.8914C95.7961 20.2175 93.8349 14.8659 89.311 12.5588C84.7869 10.2516 79.3035 11.8066 76.598 16.037C76.5979 16.0373 76.5977 16.0376 76.5975 16.0378L53.63 51.8858L25.4044 41.9348L25.4011 41.9336C20.7343 40.2919 15.6181 42.394 13.393 46.757L13.2673 47.0035C11.0423 51.3665 12.345 56.742 16.4142 59.5556L16.4171 59.5576L41.0459 76.5614L25.5154 116.202C25.5153 116.202 25.5152 116.203 25.5151 116.203C23.6794 120.877 25.6406 126.229 30.1646 128.536C34.6887 130.843 40.1722 129.288 42.8776 125.058C42.8777 125.057 42.8779 125.057 42.878 125.057L65.8456 89.2088L94.0711 99.1599L94.0745 99.161C98.7413 100.803 103.857 98.7006 106.083 94.3376L106.208 94.0912C108.433 89.7282 107.131 84.3526 103.061 81.539ZM41.2994 76.7364C41.2989 76.7361 41.2983 76.7357 41.2978 76.7353L41.299 76.7362L41.2994 76.7364ZM65.5555 89.1065L65.557 89.1071C65.5563 89.1069 65.5557 89.1066 65.555 89.1064L65.5555 89.1065Z",
    stroke: "white",
    strokeWidth: 10.1882
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_228_122",
    x: 0.728133,
    y: 0.0275712,
    width: 118.019,
    height: 141.039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.18382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_122",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle01);
export default __webpack_public_path__ + "static/media/sparkle_01.d799eab638b7402de8b851842a11d68e.svg";
export { ForwardRef as ReactComponent };